import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useCarouselControls } from '../../hooks/useCarouselControls.js';
import { Img } from '../../ui-kit/Img/Img.js';
import { LinkButton } from '../../ui-kit/LinkButton/LinkButton.js';
import { renderArrows } from '../../ui-kit/LinkButton/renderArrows.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { toLocalNumberFormat } from '../../utils/toLocalNumberFormat.js';
export const InsuranceAmountBlockInner = JSX(({ className = '', cards = [], button }) => {
    const [selectedCardIndex, setSelectedCardIndex] = useState(0);
    const handleSelectedCardIndex = useCallback((_) => setSelectedCardIndex(_), []);
    const galleryLength = cards.length;
    const CARD_VIEW_COUNT = 2;
    const [activeIndex, controls] = useCarouselControls({
        itemCount: galleryLength,
        visibleItemCount: CARD_VIEW_COUNT,
    });
    const { canDec, canInc } = controls;
    const activeHref = cards[activeIndex]?.href;
    return (_jsxs("section", { role: "listitem", className: `min-w-full text-center ${className}`, children: [_jsxs("div", { className: "relative overflow-hidden", "aria-label": "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u044B\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B", children: [galleryLength
                        ? renderGallery({
                            activeIndex,
                            cards,
                            selectedCardIndex,
                            onClick: handleSelectedCardIndex,
                        })
                        : null, renderArrows({
                        ...controls,
                        btnClass: ['left-12', 'right-12'],
                        className: 'top-16',
                    }), canDec ? (_jsx("div", { className: "absolute top-0 left-0 h-full w-32 bg-opacity-from-white" })) : null, canInc ? (_jsx("div", { className: "absolute top-0 right-0 h-full w-32 bg-opacity-to-white" })) : null] }), _jsx(LinkButton, { className: "w-60 text-center", version: "primary", ...button, href: activeHref })] }));
});
function renderGallery({ activeIndex, cards, selectedCardIndex, onClick }) {
    const tabsShiftWidth = activeIndex * 460;
    const cardsAlignStyle = cards.length > 2 ? 'justify-start' : 'justify-center';
    return (_jsx("div", { style: { transform: `translateX(-${tabsShiftWidth}px)` }, className: "duration-1000 px-6xl", children: _jsx("div", { className: `w-full flex flex-nowrap gap-s pb-6xl ${cardsAlignStyle}`, children: cards.map((slide, i) => renderNavButton({
                slide,
                i,
                isActive: Boolean(i === selectedCardIndex),
                onClick: () => onClick(i),
            })) }) }));
}
function renderNavButton({ slide, i, isActive, onClick }) {
    const btnClassName = isActive
        ? 'shadow-dark-blue border-primary-main'
        : `ease-in duration-300 border-gray`;
    return (_jsxs("button", { type: "button", onClick: onClick, className: `p-3xl min-w-fit flex items-center gap-2xl bg-white border-solid border relative ${btnClassName}`, children: [slide?.icon ? (_jsx(Img, { className: "p-lg rounded-full bg-secondary-light", image: slide.icon, width: "108", height: "108" })) : null, _jsxs("div", { className: "flex gap-s", children: [slide?.sum ? renderValueBlock('страховая сумма', slide.sum) : null, slide?.fee ? renderValueBlock('страховой взнос', slide.fee) : null] }), renderDoneIcon(isActive)] }, String(i)));
}
function renderValueBlock(title, sum) {
    return (_jsxs("div", { className: "flex flex-col text-left whitespace-pre", children: [_jsxs(Text, { size: "text-h6", children: [toLocalNumberFormat(2)(sum), " \u20BD"] }), _jsx("div", { className: "mt-2xs", children: _jsx(Text, { size: "text-l", color: "text-secondary-text", children: title }) })] }));
}
function renderDoneIcon(isActive) {
    return isActive ? (_jsx(Img, { className: `h-6 w-6 min-w-6 min-h-6 absolute right-4 top-4`, image: { icon: 'DoneIcon' }, width: "24", height: "24" })) : null;
}
//# sourceMappingURL=InsuranceAmountBlockInner.js.map